import { c as _c } from "react/compiler-runtime";
import { ButtonType } from '@systemeio/ui';
import { ActionButtonBaseProps } from 'modules/stores/store/components/item-actions';
import { FC, PropsWithChildren } from 'react';
interface ActionButtonProps extends ActionButtonBaseProps {
  ButtonComponent: FC<ButtonType>;
}
export const ActionButton: FC<PropsWithChildren<ActionButtonProps>> = t0 => {
  const $ = _c(6);
  const {
    ButtonComponent,
    onClick,
    isFetching,
    disabled,
    children
  } = t0;
  let t1;
  if ($[0] !== ButtonComponent || $[1] !== children || $[2] !== disabled || $[3] !== isFetching || $[4] !== onClick) {
    t1 = onClick ? <ButtonComponent onClick={onClick} disabled={disabled} isFetching={isFetching}>{children}</ButtonComponent> : null;
    $[0] = ButtonComponent;
    $[1] = children;
    $[2] = disabled;
    $[3] = isFetching;
    $[4] = onClick;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};